import { render } from "./arch-section.vue?vue&type=template&id=3b8814f8"
import script from "./arch-section.vue?vue&type=script&lang=js"
export * from "./arch-section.vue?vue&type=script&lang=js"

import "./arch-section.vue?vue&type=style&index=0&id=3b8814f8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__